// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"page-primaryButton-aVp0b5","wrapper":"page-wrapper-BSLGQG","pageHeader":"page-pageHeader-wZjJxu"};